/* eslint-disable jsx-a11y/anchor-is-valid */
import LOGO from "../assets/images/logo.png";
import React, { Component } from "react";
import { tokens, POST, removeStorage, getStorage, loading } from "../components/CustomComponent.js";
import { Modal } from "react-bootstrap";
import "../assets/css/bootstrap.css";

export default class LoginScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      password: "",

      modal_login: false,
      modal_alert: false,
      modal_ip: false,

      show: true,
    };
  }

  componentDidMount() {
    loading(false);
    // this.ResetPasswordOwner();
    let first_page = getStorage("first_page");
    let project_id = getStorage("project_id");
    if (tokens && first_page) {
      window.location.href = project_id ? first_page : "/choose-project";
    } else {
      removeStorage();
    }
  }
  Login = async () => {
    loading(true)
    let data = {
      username: this.state.username,
      password: this.state.password,
      remember: true,
    };
    let result = await POST("", "v1/TH/login", data);
    let role = [];
    let first_page = "";
    if (result && result.status) {
      for (let r of result.data.detail.role_data.role_detail) {
        if (first_page === "") {
          first_page = r.menu_name;
        }
        role.push({
          name: r.menu_name,
          role: [r.permission.view === "true" ? 1 : 0, r.permission.create === "true" ? 1 : 0, r.permission.update === "true" ? 1 : 0, r.permission.delete === "true" ? 1 : 0, r.permission.download === "true" ? 1 : 0, r.permission.upload === "true" ? 1 : 0],
        });
      }
      localStorage.setItem("token", "token " + result.data.token);
      // backend (detail_role_json) ไม่ส่ง username กลับมา — ใช้ค่าที่ผู้ใช้กรอกแทน กันเก็บเป็นข้อความ "undefined"
      localStorage.setItem("username", result.data.detail.username || data.username || "");
      localStorage.setItem("full_name", result.data.detail.full_name);
      localStorage.setItem("user_id", result.data.detail.user_id);
      localStorage.setItem("user_code", result.data.detail.user_code);
      localStorage.setItem("user_type", result.data.detail.user_type);
      localStorage.setItem("role_detail", JSON.stringify(role));
      localStorage.setItem("first_page", first_page);
      window.location.href = "/choose-project";
    }
    loading(false)
  };
  ResetPasswordOwner = async () => {
    let dataS = "";
    let resultS = await POST("", "v1/TH/user-admin/reset-password", dataS);
    if (resultS && resultS.status) {
      console.log("CDS success...");
    } else {
      console.error("CDS fail...");
    }
  };
  render() {
    return (
      <div className="w-100 position-relative">
        {this.state.loading && (
          <div className="spinner-container">
            <div className="loading-spinner"></div>
          </div>
        )}
        <div className="w-100 min-vh-100 d-flex align-items-center justify-content-center">
          <div className="col-10 col-sm-10 col-md-8 col-lg-6 col-xl-4 fade-in-slide-up">
            <div className="w-100 text-center">
              <img className="mb-4 pointer" alt="logo" src={LOGO} style={{ width: "60%", maxWidth: 200 }} />
            </div>
            <div className="card border-0 shadow">
              <div className="col-12 p-4">
                <h4 className="mb-4">
                  <b>ลงชื่อเข้าใช้</b>
                </h4>
                <input
                  className="form-control mb-4 border-0 bg-contain"
                  type="text"
                  placeholder="Username/Email"
                  name="username"
                  autoComplete="username"
                  value={this.state.username}
                  onChange={(e) => {
                    this.setState({ username: e.target.value });
                  }}
                />
                <div className="position-relative">
                  <input
                    className="form-control mb-4 border-0 bg-contain"
                    type={this.state.show ? "password" : "text"}
                    placeholder="รหัสผ่าน"
                    name="password"
                    autoComplete="current-password"
                    value={this.state.password}
                    onChange={(e) => {
                      this.setState({ password: e.target.value });
                    }}
                    onKeyUp={(e) => {
                      if (e.key === "Enter") this.Login();
                    }}
                  />
                  <label
                    className="position-absolute icon pointer"
                    style={{ right: 12, top: 8 }}
                    onClick={() => {
                      this.setState({ show: !this.state.show });
                    }}
                  >
                    {this.state.show ? "\uf070" : "\uf06e"}
                  </label>
                </div>
                <button
                  type="button"
                  className="btn btn-primary w-100"
                  onClick={() => {
                    this.Login();
                  }}
                >
                  เข้าสู่ระบบ
                </button>
                <div className="w-100 text-center mt-3">
                  {" "}
                  <small className="text-secondary">{process.env.REACT_APP_VERSION}</small>{" "}
                  <br/>
                  <small className="text-8">
                ©copy right by  c.d.s. service .co.,ltd and OMS service {" "}
              </small>
                </div>
              </div>
            </div>
          </div>
        </div>
        <span
          className="position-absolute icon pointer"
          style={{ top: 12, right: 12 }}
          onClick={() => {
            let ip_address = localStorage.getItem("ip_address");
            this.setState({ modal_ip: true, ip_address });
          }}
        >
          {"\uf013"}
        </span>
        <Modal
          show={this.state.modal_ip}
          onHide={() => {
            this.setState({ modal_ip: false });
          }}
        >
          <Modal.Header>
            <Modal.Title>
              <b>ตั้งค่า IP ADDRESS</b>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {/* IP address */}
            <div className="w-100 d-flex align-items-center  mb-3">
              <label className="wpx-140">IP address :</label>
              <input
                className="form-control border-0 bg-contain"
                type="text"
                placeholder="กรอกข้อมูล"
                onChange={(e) => {
                  this.setState({ ip_address: e.target.value });
                }}
                value={this.state.ip_address}
              />
            </div>
            {/* ปุ่ม */}
            <div className="w-100 d-flex">
              <div className="w-50 p-1">
                <button
                  className="btn btn-outline-primary w-100"
                  onClick={() => {
                    this.setState({ modal_ip: false });
                  }}
                >
                  ยกเลิก
                </button>
              </div>
              <div className="w-50 p-1">
                <button
                  className="btn btn-dark w-100"
                  onClick={() => {
                    localStorage.setItem("ip_address", "");
                    this.setState({ modal_ip: false, ip_address: "" });
                  }}
                >
                  ล้างค่า
                </button>
              </div>
              <div className="w-50 p-1">
                <button
                  className="btn btn-primary w-100"
                  onClick={() => {
                    localStorage.setItem("ip_address", this.state.ip_address);
                    this.setState({ modal_ip: false });
                  }}
                >
                  บันทึก
                </button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}
